import React from 'react';
import { Bar } from 'react-chartjs-2';

interface PerformanceRecord {
  c42: string; // 고객명
  c26: number; // 매출액
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const CustomerSalesHistogram: React.FC<Props> = ({ records, colors }) => {
  // 고객명별 매출액 합계 집계
  const customerMap: Record<string, number> = {};
  records.forEach(rec => {
    if (rec.c42) customerMap[rec.c42] = (customerMap[rec.c42] || 0) + rec.c26;
  });
  // 매출액 내림차순 정렬, 최대 30명
  const sorted = Object.entries(customerMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 30);
  const labels = sorted.map(([name]) => name);
  const values = sorted.map(([, value]) => value);

  return (
    <div className="chart bar-chart">
      <Bar
        data={{
          labels,
          datasets: [
            {
              label: '총 매출액',
              data: values,
              backgroundColor: labels.map((_, i) => colors[i % colors.length]),
            },
          ],
        }}
        options={{
          indexAxis: 'x', // 수직 막대
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed.y;
                  return `총 매출액: ${value.toLocaleString()}원`;
                }
              }
            }
          },
          scales: {
            x: {
              title: { display: true, text: '고객명' },
              ticks: {
                autoSkip: false,
                maxRotation: 60,
                minRotation: 30,
                font: { size: 11 }
              }
            },
            y: {
              title: { display: true, text: '총 매출액' },
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            }
          }
        }}
        height={400}
      />
    </div>
  );
};

export default CustomerSalesHistogram; 